if (!customElements.get("parallax-background-banner")) {
  const waitForGSAP = (triesLeft = 60) =>
    new Promise((resolve) => {
      const hasDeps = typeof window.gsap !== "undefined" && typeof window.ScrollTrigger !== "undefined";
      if (hasDeps || triesLeft <= 0) return resolve(hasDeps);
      window.setTimeout(() => resolve(waitForGSAP(triesLeft - 1)), 50);
    });

  const init = () => {
    const { gsap, ScrollTrigger } = window;
    if (!gsap || !ScrollTrigger) return;

    gsap.registerPlugin(ScrollTrigger);

    const blocks = gsap.utils.toArray(".parallax-background-banner");
    if (!blocks.length) return;

    const mm = gsap.matchMedia();

    function initParallax({ bgSpeed, contentSpeed, productSpeed }) {
      const triggers = [];

      blocks.forEach((block, index) => {
        const isFirst = index === 0;

        // Layers (back → front)
        // - bg: "waves/background" picture layer(s)
        // - content: overlay text/buttons
        // - product: a foreground image if it exists (NOT the background <picture> img)
        const bg = block.querySelector(".hero__pic");
        const content = block.querySelector(".hero__overlay");
        const product = Array.from(block.querySelectorAll(".hero__img")).find(
          (img) => !img.closest(".hero__pic"),
        );

        const triggerConfig = {
          trigger: block,
          start: isFirst ? "top top" : "top bottom",
          end: "bottom top",
          scrub: true,
          invalidateOnRefresh: true,
        };

        if (bg) {
          const t = gsap.to(bg, {
            yPercent: bgSpeed,
            ease: "none",
            overwrite: "auto",
            scrollTrigger: triggerConfig,
          });
          triggers.push(t.scrollTrigger);
        }

        if (content) {
          const t = gsap.to(content, {
            yPercent: contentSpeed,
            ease: "none",
            overwrite: "auto",
            scrollTrigger: triggerConfig,
          });
          triggers.push(t.scrollTrigger);
        }

        if (product) {
          const t = gsap.to(product, {
            yPercent: productSpeed,
            ease: "none",
            overwrite: "auto",
            scrollTrigger: triggerConfig,
          });
          triggers.push(t.scrollTrigger);
        }
      });

      ScrollTrigger.refresh();

      return () => {
        triggers.forEach((t) => t.kill());

        blocks.forEach((block) => {
          const bg = block.querySelector(".hero__pic");
          const content = block.querySelector(".hero__overlay");
          const product = Array.from(block.querySelectorAll(".hero__img")).find(
            (img) => !img.closest(".hero__pic"),
          );

          [bg, content, product].forEach((el) => {
            if (el) gsap.set(el, { clearProps: "transform" });
          });
        });
      };
    }

    mm.add(
      {
        mobile: "(max-width: 900px)",
        desktop: "(min-width: 901px)",
      },
      (context) => {
        const { mobile, desktop } = context.conditions;

        if (mobile) {
          return initParallax({
            bgSpeed: 15,
            contentSpeed: -20,
            productSpeed: -40,
          });
        }

        if (desktop) {
          return initParallax({
            bgSpeed: 20,
            contentSpeed: -30,
            productSpeed: -80,
          });
        }
      },
    );
  };

  // In this theme, GSAP/ScrollTrigger are loaded per-section and may be async.
  // Wait until both globals are available, then init.
  document.addEventListener("DOMContentLoaded", async () => {
    const ok = await waitForGSAP();
    if (!ok) return;
    init();
  });
}